import { render, staticRenderFns } from "./datauth.vue?vue&type=template&id=797b23ba&"
import script from "./datauth.vue?vue&type=script&lang=js&"
export * from "./datauth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports